import React, { useState, useEffect, useRef, useContext } from "react";
import { Tag } from "primereact/tag";
import { Toast } from 'primereact/toast';
import CryptoJS from 'crypto-js';

// Componentes para CRUD de usuarios
import ModalAgregarUsuario from "./ModalScreenUsuario/ModalAgregarUsuario";
import ModalEditarUsuario from "./ModalScreenUsuario/ModalEditarUsuario";

// Servicios generales de la apliaccion

import { Button } from "primereact/button";
import { getPassUser, getUsuarios } from "../../../API/IT/Usuarios/UsersRequests";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { encryptor, getSymmetricKey } from "../../../Base/Services/Crypto/Crypto";
import { toastShow } from "../../../Base/Services/ToastService";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import Card from "../../../Base/Components/Card/Card";
import { getRoles } from "../../../API/IT/Roles/RolesRequests";
import './UsuariosStyles.scss'
import AgregarFirma from './AgregarFirma'

export const UsuariosScreen = () => {

    const toast = useRef(null);

    const { config } = useContext(ConfigContext)


    // Variables de edicion 
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [userEdit, setuserEdit] = useState(null);
    const [selected, setSelected] = useState(null);
    const [showAddFirma, setShowAddFirma] = useState(false);
    const [roles, setRoles] = useState([]);


    const getUsers = async () => {
        setLoading(true);
        setUsuarios([]);
        const r = await getRoles();
        setRoles(r);
        const u = await getUsuarios()
        const t = u.map(e => {
            return {
                ...e,
                IdSecciones: e?.Secciones ? e?.Secciones.split(',') : [],
                AreasConsulta: e?.AreasConsulta ? e?.AreasConsulta.split(',').map(e => parseInt(e)) : []

            }
        })
        setUsuarios(t)
        setLoading(false);
    }

    useEffect(() => {
        setTitlePage(getLabel(baseLang, 'users', config.language))
        getUsers();
        // <ModalMessage usuarios= {usuarios}/>
    }, []);

    const statusBodyTemplate = (rowData) => {
        if (rowData.StatusName) {
            if (rowData.StatusName === "Active") {
                return <Tag className="col-12" severity="success" value={rowData.StatusName} />
            }
            else {
                return <Tag className="col-12" severity="danger" value={rowData.StatusName} />
            }
        } else {
            return null
        }

    }


    const Botones = ({ rowData }) => {
        const [password, setPassword] = useState('');
        const getPassworduser = async (rowData) => {
            const key = await getSymmetricKey();
            const keyEncryptada = await encryptor(JSON.stringify({ key: key.exportKey, idUser: rowData.idUser }));
            const pass = await getPassUser(keyEncryptada);
            var decrypted = CryptoJS.AES.decrypt(pass, key.exportKey).toString(CryptoJS.enc.Utf8);
            setPassword(decrypted);
            const text = document.createElement('textarea');
            text.value = decrypted;
            text.setAttribute("readonly", "");
            document.body.appendChild(text)
            text.select()
            document.execCommand('copy')
            document.body.removeChild(text);

            toastShow(toast, 'success', 'Contraseña copiada')

            setTimeout(() => {
                setPassword(null)
            }, 5 * 1000);
        }
        return <div className="d-flex" >
            <Button icon="pi pi-pencil" className="p-button-infop p-button-text p-0" onClick={e => {
                setuserEdit(rowData);
            }} />
            <Button icon="pi pi-lock" className=" p-button-infop p-button-text  p-0" onClick={(e) => {
                getPassworduser(rowData)
            }} tooltip={password} tooltipOptions={{ position: 'left' }} />

        </div>
    }

    const columns = [
        {
            header: 'idUser',
            field: 'idUser',
            className: 'Xsmall'
        },
        {
            header: 'Codigo',
            field: 'idPersonal',
            className: 'Xsmall'
        },
        {
            header: 'Estado',
            field: 'StatusName',
            Format: 'Template',
            className: 'Xsmall',
            body: e => statusBodyTemplate(e)
        },
        {
            header: 'Usuario',
            field: 'Usuario',
        },
        {
            header: 'Nombre',
            field: 'UserName',
            Sumary: 'count'
        },
        {
            header: 'Mail',
            field: 'Mail',
            className: 'large'
        },
        {
            header: 'Rol',
            field: 'Rol',
        },
        // {
        //     header: 'Rol',
        //     field: 'Rol',
        //     editable: true,
        //     value: 'IdRol',
        //     label: 'Rol',
        //     items: roles,
        //     Format: 'AutoComplete'
        // },
        {
            header: 'AreasConsulta',
            field: 'AreasNombre',
        },

        {
            header: 'Gerencia',
            field: 'NombresSeccion',
            // flex: 1
        },
        {
            field: "IdUser",
            className: "",
            header: "",
            Format: "Botones",
            frozen: true,
            alignFrozen: "right",
            filter: false,
            Botones: [
              {
                icon: "ri-draft-line",
                tooltip: "Agregar Firma",
                onClick: (rowData) => {
                    setSelected(rowData)
                    setShowAddFirma(true);
                },
              },
            ],
        },

        {
            // Botones
            field: 'Botones',
            header: '',
            Format: 'Template',
            body: e => e.idUser ? <Botones rowData={e} /> : null,
            frozen: true,
            alignFrozen: 'right',
            className: 'xsmall',

        },

    ]

    const table = {
        Columns: columns,
        Data: usuarios,
        loading: loading
    }





    return (
        <div className="usuarios__contenedor p-2" >
            <ModalEditarUsuario getUsers={getUsers} userEdit={userEdit} setuserEdit={setuserEdit} />
            <Toast position="bottom-right" ref={toast}></Toast>
            <Card
                titulo={<div className="botones">
                    <h3>{getLabel(baseLang, 'users', config.language)}</h3>
                    <Button icon='pi pi-search' className="mx-2" onClick={getUsers} />
                    <ModalAgregarUsuario usuarios={getUsers} />
                </div>}
                contenido={<div className="p-4" style={{ height: '90vh' }}>
                    <AgGrid table={table} />

                </div>}
            />

            {showAddFirma && (
                <AgregarFirma
                    showAddFirma={showAddFirma}
                    setShowAddFirma={setShowAddFirma}
                    userEdit={selected}
                    toast={toast}
                />
            )}
        </div>
    )
}


export default UsuariosScreen;


